import type { NewUserQuizCopy, NewUserQuizLocale, NewUserQuizLocalization } from './types';

import { DE_NEW_USER_QUIZ_COPY } from './locales/de';
import { EN_NEW_USER_QUIZ_COPY } from './locales/en';
import { ES_NEW_USER_QUIZ_COPY } from './locales/es';
import { IT_NEW_USER_QUIZ_COPY } from './locales/it';
import { RU_NEW_USER_QUIZ_COPY } from './locales/ru';

const DEFAULT_LOCALE: NewUserQuizLocale = 'en';
const SUPPORTED_LOCALES = new Set<NewUserQuizLocale>(['de', 'en', 'es', 'it', 'ru']);

const COPY_BY_LOCALE: Record<NewUserQuizLocale, NewUserQuizCopy> = {
  de: DE_NEW_USER_QUIZ_COPY,
  en: EN_NEW_USER_QUIZ_COPY,
  es: ES_NEW_USER_QUIZ_COPY,
  it: IT_NEW_USER_QUIZ_COPY,
  ru: RU_NEW_USER_QUIZ_COPY,
};

const getBrowserLanguagePreferences = (): readonly string[] => {
  if (typeof navigator === 'undefined') {
    return [];
  }

  const preferences = navigator.languages.length > 0 ? [...navigator.languages] : [];
  if (navigator.language && !preferences.includes(navigator.language)) {
    preferences.push(navigator.language);
  }
  return preferences;
};

export const resolveNewUserQuizLocale = (languagePreferences: readonly string[]): NewUserQuizLocale => {
  for (const preference of languagePreferences) {
    const locale = preference.trim().toLowerCase().split(/[-_]/, 1)[0];
    if (SUPPORTED_LOCALES.has(locale as NewUserQuizLocale)) {
      return locale as NewUserQuizLocale;
    }
  }

  return DEFAULT_LOCALE;
};

export const getNewUserQuizLocalization = (
  languagePreferences: readonly string[] = getBrowserLanguagePreferences(),
): NewUserQuizLocalization => {
  const locale = resolveNewUserQuizLocale(languagePreferences);
  return { copy: COPY_BY_LOCALE[locale], locale };
};

export type { NewUserQuizCopy, NewUserQuizLocale, NewUserQuizLocalization } from './types';
